export const homepageCanonicalLink = { rel: "canonical", href: "https://entire.com" } as const
